module.exports = __webpack_public_path__ + "img/ring_r_l_0_1@3x.8c369981.png";